import {addClass, findAll, findID, find, listener, removeClass, wrap} from "../../../../modules/vegas/js/util";
import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {VGFormSender} from "vgformsender";
import {VGSelect} from "vgselect";
import {Modal} from "../esm";
import {VGSidebar} from "vgnav/src/VGSidebar";
import VGMap from "../../../../modules/vegas/js/map";

const VGListener = {
	onReady: () => {
		VG.plugins.init();
		VG.defaults();
		VG.Scroll.toTop.init();
		VG.Scroll.Header.init();
		VG.Scroll.loadMap.init('yaMap');

		// [vegas]
		VG.log();
	},

	onScroll: (event) => {
		VG.Scroll.toTop.init();
		VG.Scroll.Header.init();
		VG.Scroll.loadMap.init('yaMap');
	},

	onResize: (event) => {

	},
}

const VG = {
	log: function (errors = []) {
		if (!errors.length) {
			console.log("%cVG app was initialization","color: green;");
		} else {
			errors.forEach(function (item) {
				console.error(item);
			});
		}
	},

	plugins: {
		init: () => {
			//VG.plugins.enableAOS();
			VG.plugins.enableVGSelect();
			VG.plugins.enableVGNav();
			VG.plugins.enableLawCookie();
			VG.plugins.enableFormSender();
			VG.plugins.enableFormSendLoadings();
		},

		enableVGNav: function () {
			new VGNav({
				expand: 'lg',
				toggle: false
			}, {
				beforeClick: function () {
					let $sidebar = new VGSidebar('#vg-nav-sidebar');
					$sidebar.close({}, true);
				}
			});
		},

		enableAOS: function ()  {
			AOS.init({once: true});
		},

		enableVGSelect: function ()  {
			let elements = findAll('.vg-select');
			for (const element of elements) {
				new VGSelect(element, {})
			}
		},

		enableLawCookie: function () {
			new VGLawCookie();
		},

		enableFormSender: function () {
			const forms = findAll('[data-vgformsender]');
			if (forms.length) {
				[...forms].map((form) => {
					new VGFormSender(form, {
						modal: Modal
					}).submit();
				})
			}
		},

		enableFormSendLoadings: function () {
			listener('submit', 'form', function (form) {
				let btn = form.querySelector('button[type="submit"]'),
					text = btn.dataset.loadingText;

				if (text) {
					btn.innerText = text;
					btn.setAttribute('disabled', 'disabled')
				}
			});
		},
	},

	defaults: wrapper => {
		// Манипуляции с контентом по умолчанию
		let pages = findAll('.page-default');
		if (pages.length) {
			[...pages].map((page) => {
				// image
				let images = findAll('img', page);
				if (images && images.length) {
					[...images].map((img) => {
						addClass(img, 'img-fluid')
					})
				}

				let imagesFancy = findAll('a[href=""][data-fancybox] img', page);
				if (imagesFancy && imagesFancy.length) {
					[...imagesFancy].map((img) => {
						let a = img.closest('a');
						a.setAttribute('href', img.getAttribute('src'));
					})
				}

				// table
				let tables = findAll('table', page);
				if (tables && tables.length) {
					[...tables].map((table) => {
						addClass(table, ['table', 'table-hover', 'table-bordered'])
						wrap(table, 'table-responsive');
					})
				}
			})
		}
	},

	Scroll: {
		toTop: {
			position: 400,
			btn: 'btn-scroll-to-top',

			init: function () {
				let $layoutScrollToTop = findID(this.btn);

				if (!$layoutScrollToTop) {
					let div = document.createElement('div');
					addClass(div, 'to-top');
					div.setAttribute('id', this.btn);
					div.innerHTML = '<span><i class="fal fa-chevron-up"></i></span>';

					document.body.append(div);
				}

				this.setPosition();

				listener('click', '#' + this.btn, function () {
					window.scrollTo(0, 0);
				});
			},

			setPosition: function () {
				let $sticky = findID(this.btn);

				if (document.documentElement.scrollTop >= this.position) {
					addClass($sticky, 'is-active')
				} else {
					removeClass($sticky, 'is-active')
				}
			}
		},

		loadMap: {
			isInit: false,
			init: function (map) {
				let $map = findID(map);

				if ($map) {
					let offsetTop = $map.getBoundingClientRect().top,
						windowHeight = window.innerHeight,
						offset = offsetTop - windowHeight;

					if (offset < 100 && !this.isInit) {
						VGMap.init($map, {
							callback: {
								afterInitMap: function (map, params, _this) {
									_this.PlaceMark.set(map, params);
								}
							}
						});

						this.isInit = true;
					}
				}
			}
		},

		Header: {
			lastScrollTop: 0,
			minStartScroll: 350,
			body: document.body,
			stickyArea: [...findAll('.sticky-area')],
			height: {
				window: window.innerHeight
			},

			init: function () {
				let $sticky = find('.header-wrapper'),
					scroll = document.documentElement.scrollTop;

				if ($sticky) {
					if (scroll > this.minStartScroll) {
						addClass(this.body, 'header--is-scroll');
						addClass($sticky,'scroll');

						if (scroll > this.lastScrollTop) {
							removeClass($sticky,'fixed');
							removeClass(this.body,'header--is-fixed');

							if (this.stickyArea.length) {
								this.stickyArea.forEach((sticky) => removeClass(sticky,'fixed'));
							}
						} else {
							addClass($sticky,'fixed');
							addClass(this.body,'header--is-fixed');

							if (this.stickyArea.length) {
								this.stickyArea.forEach((sticky) => addClass(sticky,'fixed'));
							}
						}

						this.lastScrollTop = scroll;
					} else if (scroll < this.minStartScroll) {
						removeClass($sticky, 'scroll fixed')
						removeClass(this.body,'header--is-scroll header--is-fixed');
					}
				}
			},
		}
	}
}
export default VGListener;
